
import mixin from "./mixin";
import { Component, Mixins } from "vue-property-decorator";
import * as modals from "@/lib/modals";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import { DeleteTruckResponse } from "../../../models/api/trucks/deleteTrucks";
import notifications from "../../../lib/notifications";
import { formatDate } from "../../../utils";

const truckModuleState = getModule(TruckModule);

@Component({ name: modals.deleteTruckModal })
export default class DeleteTruckModal extends Mixins(mixin) {
  response: DeleteTruckResponse = null;
  loading: boolean = true;
  deleting: boolean = false;
  canDelete: boolean = false;
  deliveryDateFormatted: string = null;
  truckId: number = null;

  async load() {
    this.show();
    let selectedTruck = this.selectedItem;
    this.truckId = selectedTruck.id;
    try {
      this.response = await truckModuleState.deleteTruck({
        truckId: this.truckId,
        confirm: false
      });
      this.deliveryDateFormatted = formatDate(this.response.deliveryDate);
      this.canDelete = true;
    } catch (ex) {}
    this.loading = false;
  }

  async deleteTruck() {
    this.deleting = true;
    try {
      const response = await truckModuleState.deleteTruck({
        truckId: this.truckId,
        confirm: true
      });
      notifications.success("Delete Truck", "Truck successfully deleted.");
      this.hideModal();
    } catch (ex) {
      notifications.error("Delete Truck", "Failed to delete truck", ex);
    }
    this.deleting = false;
  }

  reset() {
    this.response = null;
    this.loading = true;
    this.deleting = false;
    this.canDelete = false;
    this.truckId = null;
    this.deliveryDateFormatted = null;
  }
}
